import {
    createMobeesCampaignApiConfig,
    getMobeesDraftCampaignApiConfig, updateMobeesCampaignApiConfig,
} from '@domain/partnerships/partners/mobees/new-campaign/campaign/campaign.api';
import { createReducer, INITIAL_STATE } from '@shared/redux';
import { LOAD_STATE } from '@shared/axios';
import {
    formatCampaign, formatDraftCampaign,
} from '@domain/partnerships/partners/mobees/new-campaign/campaign/campaign.utils';

export interface CampaignState {
    data: {
        id?: string,
        name: string,
        startDate: Date,
        endDate: Date,
        budget: number,
        location: string
    };
    loadState: string;
    error: any;
}

export const CREATE_CAMPAIGN_REQUEST_CALLED = '@mobees/newCampaign/CREATE_CAMPAIGN_REQUEST_CALLED';
export const CREATE_CAMPAIGN_REQUEST_SUCCEEDED = '@mobees/newCampaign/CREATE_CAMPAIGN_REQUEST_SUCCEEDED';
export const CREATE_CAMPAIGN_REQUEST_FAILED = '@mobees/newCampaign/CREATE_CAMPAIGN_REQUEST_FAILED';

export const UPDATE_CAMPAIGN_REQUEST_CALLED = '@mobees/newCampaign/UPDATE_CAMPAIGN_REQUEST_CALLED';
export const UPDATE_CAMPAIGN_REQUEST_SUCCEEDED = '@mobees/newCampaign/UPDATE_CAMPAIGN_REQUEST_SUCCEEDED';
export const UPDATE_CAMPAIGN_REQUEST_FAILED = '@mobees/newCampaign/UPDATE_CAMPAIGN_REQUEST_FAILED';

export const GET_DRAFT_CAMPAIGN_REQUEST_CALLED = '@mobees/newCampaign/GET_DRAFT_CAMPAIGN_REQUEST_CALLED';
export const GET_DRAFT_CAMPAIGN_REQUEST_SUCCEEDED = '@mobees/newCampaign/GET_DRAFT_CAMPAIGN_REQUEST_SUCCEEDED';
export const GET_DRAFT_CAMPAIGN_REQUEST_FAILED = '@mobees/newCampaign/GET_DRAFT_CAMPAIGN_REQUEST_FAILED';

export const RESET_CAMPAIGN = '@mobees/newCampaign/RESET_CAMPAIGN';
export const REEVALUATE_AD_DURATION = '@mobees/newCampaign/REEVALUATE_AD_DURATION';

export const getCampaignSettings = state => state.partnerships.mobees.newCampaign.campaign;

export const getDraftMobeesCampaign = () => ({
    type: GET_DRAFT_CAMPAIGN_REQUEST_CALLED,
    actionTypes: {
        success: GET_DRAFT_CAMPAIGN_REQUEST_SUCCEEDED,
        fail: GET_DRAFT_CAMPAIGN_REQUEST_FAILED,
    },
    config: getMobeesDraftCampaignApiConfig(),
});

export const createMobeesCampaign = data => ({
    type: CREATE_CAMPAIGN_REQUEST_CALLED,
    actionTypes: {
        success: CREATE_CAMPAIGN_REQUEST_SUCCEEDED,
        fail: CREATE_CAMPAIGN_REQUEST_FAILED,
    },
    config: createMobeesCampaignApiConfig(data),
});


export const updateMobeesCampaign = (campaignId, data) => ({
    type: UPDATE_CAMPAIGN_REQUEST_CALLED,
    actionTypes: {
        success: UPDATE_CAMPAIGN_REQUEST_SUCCEEDED,
        fail: UPDATE_CAMPAIGN_REQUEST_FAILED,
    },
    config: updateMobeesCampaignApiConfig(campaignId, data),
});

export const getDraftCampaign = state => state.partnerships.mobees.newCampaign.campaign.data;

export const resetCampaign = () => ({
    type: RESET_CAMPAIGN,
    payload: {},
});

export const reevaluateAdDuration = (startDate, endDate) => ({
    type: REEVALUATE_AD_DURATION,
    payload: { startDate, endDate },
});

const initialState: CampaignState = {
    data: {
        id: undefined,
        name: undefined,
        startDate: undefined,
        endDate: undefined,
        budget: undefined,
        location: undefined,
    },
    loadState: LOAD_STATE.LOADING,
    error: null,
};

export const mobeesNewCampaignReducer = createReducer({
    [INITIAL_STATE]: initialState,
    [GET_DRAFT_CAMPAIGN_REQUEST_CALLED]: state => ({
        ...state,
        data: {},
        loadState: LOAD_STATE.LOADING,
        error: null,
    }),
    [GET_DRAFT_CAMPAIGN_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        data: formatDraftCampaign(action.payload.data, initialState.data),
        loadState: LOAD_STATE.SUCCESS,
        error: null,
    }),
    [GET_DRAFT_CAMPAIGN_REQUEST_FAILED]: (state, action) => ({
        ...state,
        data: {
            ...initialState.data,
        },
        loadState: LOAD_STATE.FAIL,
        error: action.payload,
    }),
    [CREATE_CAMPAIGN_REQUEST_CALLED]: state => ({
        ...state,
        loadState: LOAD_STATE.LOADING,
        error: null,
    }),
    [CREATE_CAMPAIGN_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        data: formatCampaign(action.payload.data),
        loadState: LOAD_STATE.SUCCESS,
        error: null,
    }),
    [CREATE_CAMPAIGN_REQUEST_FAILED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.FAIL,
        error: action.payload,
    }),
    [UPDATE_CAMPAIGN_REQUEST_CALLED]: state => ({
        ...state,
        loadState: LOAD_STATE.LOADING,
        error: null,
    }),
    [UPDATE_CAMPAIGN_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        data: formatCampaign(action.payload.data),
        loadState: LOAD_STATE.SUCCESS,
        error: null,
    }),
    [UPDATE_CAMPAIGN_REQUEST_FAILED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.FAIL,
        error: action.payload,
    }),
    [RESET_CAMPAIGN]: () => initialState,
});
